// src/pages/plataforma/SubirComprobante.js
// Ruta pública: /pagar/:inscripcionId
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import GlassSpinner from "../../components/GlassSpinner";

const API  = "https://mocaub1h8d.execute-api.us-east-1.amazonaws.com/prod";
const GOLD = "#dfa66b";

const fileToBase64 = (file) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result.split(",")[1]);
    r.onerror = rej;
    r.readAsDataURL(file);
  });

export default function SubirComprobante() {
  const { inscripcionId } = useParams();

  const [info, setInfo]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [done, setDone]       = useState(false);
  const [error, setError]     = useState("");
  const [file, setFile]       = useState(null);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    axios.post(`${API}/getInscripcionInfo`, { inscripcionId })
      .then(r => setInfo(r.data))
      .catch(() => setError("No se encontró la inscripción."))
      .finally(() => setLoading(false));
  }, [inscripcionId]);

  const handleFile = e => {
    const f = e.target.files[0];
    if (!f) return;
    if (f.size > 5 * 1024 * 1024) { setError("Archivo máximo 5 MB."); return; }
    setFile(f); setFileName(f.name); setError("");
  };

  const handleSubmit = async () => {
    if (!file) return setError("Seleccioná un archivo.");
    setSending(true);
    try {
      const b64 = await fileToBase64(file);
      await axios.post(`${API}/subirComprobante`, {
        inscripcionId,
        payment_proof_b64:  b64,
        payment_proof_name: file.name,
      });
      setDone(true);
    } catch { setError("Error al subir. Intentá de nuevo."); }
    setSending(false);
  };

  if (loading) return (
    <div style={styles.page}>
      <GlassSpinner size={70} background="#1a1a1a" />
    </div>
  );

  if (done) return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={{ fontSize: 56, textAlign: "center", marginBottom: 12 }}>✅</div>
        <h2 style={{ textAlign: "center" }}>¡Comprobante recibido!</h2>
        <p style={{ textAlign: "center", color: "#555", lineHeight: 1.6 }}>
          Tu comprobante fue enviado correctamente.<br />
          El organizador lo revisará y recibirás tu entrada por email.
        </p>
      </div>
    </div>
  );

  return (
    <div style={styles.page}>
      {sending && (
        <div style={styles.overlay}>
          <GlassSpinner size={80} background="#1a1a1a" />
        </div>
      )}
      <div style={styles.card}>
        <h2 style={{ textAlign: "center", marginBottom: 4 }}>Subir comprobante</h2>

        {info && (
          <p style={{ textAlign: "center", color: "#888", fontSize: 13, marginBottom: 20 }}>
            {info.first_name} {info.last_name} · {info.tandaLabel || ""}
          </p>
        )}

        {error && !info ? (
          <p style={{ color: "red", textAlign: "center" }}>{error}</p>
        ) : (
          <>
            <p style={{ fontSize: 13, color: "#555", marginBottom: 16 }}>
              Adjuntá el comprobante de transferencia o pago (imagen o PDF, máx. 5MB).
            </p>

            <label style={styles.fileBtn}>
              <input type="file" accept="image/*,application/pdf" onChange={handleFile} style={{ display: "none" }} />
              {fileName ? `📎 ${fileName}` : "Seleccionar archivo"}
            </label>

            {error && <p style={{ color: "red", marginTop: 10, textAlign: "center", fontSize: 13 }}>{error}</p>}

            <button style={{ ...styles.btn, background: GOLD }} onClick={handleSubmit}>
              Enviar comprobante
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page:    { background: GOLD, minHeight: "100vh", padding: "30px 16px", display: "flex", justifyContent: "center", alignItems: "flex-start" },
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 },
  card:    { background: "#fff", width: "100%", maxWidth: 420, padding: 24, borderRadius: 18, boxShadow: "0 4px 16px rgba(0,0,0,0.2)" },
  fileBtn: { display: "block", padding: "14px", borderRadius: 10, border: "1.5px dashed #ccc", fontSize: 14, color: "#555", cursor: "pointer", textAlign: "center", background: "#fafafa" },
  btn:     { color: "#000", padding: 14, width: "100%", borderRadius: 10, border: "none", marginTop: 20, cursor: "pointer", fontWeight: "bold", fontSize: 16 },
};
